export * from "ce/reducers/entityReducers/jsActionsReducer";
import { default as CE_jsActionsReducer } from "ce/reducers/entityReducers/jsActionsReducer";
export default CE_jsActionsReducer;
